export default __webpack_public_path__ + "static/media/elves.e57d9c8d.png";